<div class="side-menu">
    <div class="logo-hypermed-container">
        <a href="/home" (click)="routeTo($event)">
            <div class="logo-hypermed"></div>
        </a>
    </div>
    <div class="menu-buttons">
        <div class="icons-buttons" title="Dossier patient" *ngIf="canAccessDonneesMedicales && canAccessPatients">
            <a href="/user/patient" (click)="routeTo($event)">
                <button [ngClass]="{'hoveron': page === 'patient'}" class="empty-button">
                    <div class="img users"></div>
                </button>
            </a>
        </div>

        <div class="icons-buttons" title="Messagerie" *ngIf="canAccessDonneesMedicales && canAccessMessagerie">
            <a href="/user/messagerie" (click)="routeTo($event)">
                <button [ngClass]="{'hoveron': page === 'messagerie'}" class="empty-button">
                    <div class="img mail"></div>
                </button>
            </a>
        </div>

        <div class="icons-buttons" title="Agenda" *ngIf="canAccessDonneesMedicales && canAccessAgenda">
            <a href="/user/agenda" (click)="routeTo($event)">
                <button [ngClass]="{'hoveron': page === 'agenda'}" class="empty-button">
                    <div class="img calendar"></div>
                </button>
            </a>
        </div>

        <div class="icons-buttons" title="Documents">
            <a href="/user/detachedDocuments" (click)="routeTo($event)">
                <button [ngClass]="{'hoveron': page === 'detachedDocuments'}" class="empty-button">
                    <div class="img documents"></div>
                </button>
            </a>
        </div>

        <div class="icons-buttons" title="Comptabilité" *ngIf="canAccessDonneesMedicales && canAccessComptabilite">
            <a href="/user/compta" (click)="routeTo($event)">
                <button [ngClass]="{'hoveron': page === 'compta'}" class="empty-button">
                    <div class="img compta"></div>
                </button>
            </a>
        </div>

        <div class="icons-buttons" title="Utilitaires" *ngIf="canAccessUtilitaires">
            <a href="/user/utilitaires" (click)="routeTo($event)">
                <button [ngClass]="{'hoveron': page === 'utilitaires' || page === 'recherche' || page === 'correspondant'
                    || page === 'reunions' || page === 'protocoles' }" class="empty-button">
                    <div class="img utilitaires"></div>
                </button>
            </a>
        </div>

        <div class="icons-buttons" title="Réglages du cabinet" *ngIf="canAccessSettings">
            <a href="/user/office" (click)="routeTo($event)">
                <button
                    [ngClass]="{'hoveron': page === 'office' || page === 'personnalisation' || page === 'parametres' }"
                    class="empty-button">
                    <div class="img settings"></div>
                </button>
            </a>
        </div>
    </div>
    <div class="bottom-sticky contact-sticky">
        <div class="icons-buttons" title="Contact">
            <button class="empty-button contact-button no-border" (click)="contact()">
                <div class="img contact"></div>
            </button>
        </div>
    </div>
    <div class="bottom-sticky">
        <div class="icons-buttons" title="Déconnexion">
            <button class="empty-button logout-button no-border" (click)="logout()">
                <div class="img logout"></div>
            </button>
        </div>
    </div>
    <div class="bottom-sticky">
        <span [matTooltip]="fullVersion" [matTooltipClass]="'tooltip-version'" matTooltipPosition="right"
            style="margin:auto;">
            {{getVersion()}}
        </span>
    </div>
</div>
<!-- <div class="second-menu" [ngClass]="{'no-height': !open}">

</div> -->
